import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a183b29&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2a183b29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a183b29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec/b2b/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a183b29')) {
      api.createRecord('2a183b29', component.options)
    } else {
      api.reload('2a183b29', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a183b29&scoped=true&", function () {
      api.rerender('2a183b29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/index.vue"
export default component.exports